import axios from "axios";

import Token from "../../utilities/jwt/Token.js";

export default class LocalService extends Token {
  findAll() {
    return axios({
      method: "get",
      url: this.api_url_intra + "local",
      withCredentials: true,

    }).then((res) => res.data);
  }

  findById(id) {
    return axios({
      method: 'get',
      url: this.api_url_intra + 'local/' + id,
      withCredentials: true,

    }).then((res) => res.data);
  }
}
